/**
 * 開発時だけのデバッグログを出力する
 */
export function log(...args: any[]) {
  debug(...args)
}

export function debug(...args: any[]) {
  if (process.env.NODE_ENV === 'development') {
    // biome-ignore lint/suspicious/noConsole:
    console.debug(...args)
  }
}

export function info(...args: any[]) {
  if (process.env.NODE_ENV === 'development') {
    // biome-ignore lint/suspicious/noConsole:
    console.info(...args)
  }
}

export function warn(...args: any[]) {
  if (process.env.NODE_ENV === 'development') {
    // biome-ignore lint/suspicious/noConsole:
    console.warn(...args)
  }
}

export function error(...args: any[]) {
  if (process.env.NODE_ENV === 'development') {
    // biome-ignore lint/suspicious/noConsole:
    console.error(...args)
  }
}
